import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    active: false,
    className: null,
};

const ProfileIcon = ({ active, className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        width="20.82"
        height="20.82"
        viewBox="0 0 20.82 20.82"
        fill="none"
        stroke="currentColor"
    >
        <path
            d="M15,12.56a9.26,9.26,0,0,1-4.6,1.5,9,9,0,0,1-4.6-1.5c-2.1.4-3.4,1-3.4,1.6v4.4c0,.1.4.4,2.2.6a54.41,54.41,0,0,0,5.7.3,54.41,54.41,0,0,0,5.7-.3c1.8-.2,2.2-.5,2.2-.6v-4.4C18.4,13.56,17.1,13,15,12.56Z"
            strokeMiterlimit="10"
            strokeWidth="2.5"
            fill={active ? null : null}
        />
        <path
            d="M10.4,10.63A4.5,4.5,0,0,0,15,6.27V5.33C15,3,13.26,1.38,10.51,1.38c-3.08,0-4.73,1.66-4.73,4v.94A4.5,4.5,0,0,0,10.4,10.63Z"
            strokeMiterlimit="10"
            strokeWidth="2.5"
            fill={active ? null : null}
        />
    </svg>
);

ProfileIcon.propTypes = propTypes;
ProfileIcon.defaultProps = defaultProps;

export default ProfileIcon;
